import { cn } from '@/shared/helpers/classnames'

export const LoadingIcon = ({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) => {
  return (
    <span
      className={cn(`loading loading-ring text-[var(--color-primary)]`, {
        'loading-lg': size === 'lg',
        'loading-sm': size === 'sm',
        'loading-md': size === 'md',
      })}
    />
  )
}

LoadingIcon.displayName = 'LoadingIcon'
